import React from 'react';
import Table from 'react-bootstrap/Table';
import Container from 'react-bootstrap/Container';

const ImeiListe = (props) => {
    /*const [filialen, setFilialen] = useState([]);

    useEffect(() => {
        const storedFilialen = props.filialeList;
        setFilialen(storedFilialen || []);
    }, [props.filialeList]);

    const handleChangeFiliale = (event) => {
        const filiale = event.target.dataset.filiale;
       //console.log('onChangeFiliale', filiale);
        props.onChangeFiliale(filiale);
    };*/

   //console.log(props.valueFiliale, filialen);

   /*

                ArtNr: '11112345111', 
                Bezeichnung: 'Testartikel', 
                KreditorArtNr: '123456789',
                Hersteller: '111', 
                EAN: '1234567890123'

   */

   const liste = props.artikelListeErfasst;

 //console.log('ImeiListe', liste);

    return (
        <Container fluid>
            <Table striped bordered hover size="sm">
                <thead>
                    <tr>
                    <th></th>
                    <th>ArtNr</th>
                    <th>Bezeichnung</th>
                    <th>IMEI</th>
                    <th>IMEI2</th>
                    <th>SN</th>
                    </tr>
                </thead>
                <tbody style={{ overflow: 'scroll'}}>

                    {
                        liste && liste.length > 0 
                        ?   liste.map((element, index) => {

                                if(liste.length > 20) {
                                    if(index > liste.length - 20) {
                                        return (
                                            <tr key={index}>
                                                <td>{index+1}</td>
                                                <td>{element.art}</td>
                                                <td>{element.name}</td>
                                                <td>{element.imei}</td>
                                                <td>{element.imei2}</td>
                                                <td>{element.sn}</td>
                                            </tr>
                                        );
                                    } else {
                                        return null;
                                    }
                                } else {
                                    return (
                                        <tr key={index}>
                                            <td>{index+1}</td>
                                            <td>{element.art}</td>
                                            <td>{element.name}</td>
                                            <td>{element.imei}</td>
                                            <td>{element.imei2}</td>
                                            <td>{element.sn}</td>
                                        </tr>
                                    );
                                }


                            })
                        :   null
                    }

                </tbody>
            </Table>
        </Container>
    )

};

export default ImeiListe;